/* eslint-disable react/no-array-index-key */
import { store } from 'redux/store';
import { useTranslate } from 'hooks/useTranslate';
import { format } from 'date-fns';

import { DATE_FORMAT_WITH_TIME } from 'constants/defaultConstants';
import { FC } from 'react';
import { Note } from 'types';

import EmptyStateForTable from 'modules/_shared/components/EmptyStates/EmptyStateForTable';
import { setModal } from 'modules/_shared/redux/modalActions';
import AddPartnerNoteModal from 'modules/_shared/components/Modals/AddPartnerNote';
import { AddPartnernoteModalProvider } from 'modules/_shared/components/Modals/AddPartnerNote/context/AddPartnerNoteModalContext';

type PartnerNotesSectionProps = {
  partnerId: string;
  notes: Note[];
};

const PartnerNotesSection: FC<PartnerNotesSectionProps> = ({
  partnerId,
  notes,
}) => {
  const { t } = useTranslate();

  const handleAddNote = () => {
    store.dispatch(
      setModal(
        <AddPartnernoteModalProvider partnerId={partnerId}>
          <AddPartnerNoteModal />
        </AddPartnernoteModalProvider>
      )
    );
  };

  return (
    <section className="partner-investment-wrapper mb-5">
      <div className="nk-block-head">
        <div className="nk-block-between d-flex flex-column flex-md-row">
          <div className="nk-block-head-content">
            <h4 className="nk-block-title">{t('Annotations')}</h4>
            <div className="nk-block-des">
              <p>{t('AnnotationPartnerTabDescription')}</p>
            </div>
          </div>

          <div className="nk-block-head-content">
            <div className="nk-block float-right">
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleAddNote}
              >
                <em className="icon ni ni-plus mr-1" />
                {t('AddAnnotation')}
              </button>
            </div>
          </div>
        </div>

        <div className="card card-bordered card-preview mt-4">
          <table className="table table-striped">
            <thead>
              <tr>
                <th scope="col" className="w-200px">
                  {t('Date')}
                </th>
                <th scope="col">{t('Note')}</th>
              </tr>
            </thead>

            <tbody>
              {notes?.length > 0 ? (
                notes?.map((item: Note, index: number) => (
                  <tr key={`note-row-${index}`}>
                    <td className="w-200px">
                      {format(new Date(item.date), DATE_FORMAT_WITH_TIME)}
                    </td>
                    <td>{item.text}</td>
                  </tr>
                ))
              ) : (
                <EmptyStateForTable
                  colspan={2}
                  mainMessage={t('NoAnnotations')}
                  infoMessage=""
                />
              )}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default PartnerNotesSection;
